<template>
  <v-card style="border-radius: 12px;" elevation="10" :max-width="$vuetify.breakpoint.smAndUp ? '450px' : 'auto'">
    <v-card-title class="heading">
      <v-row style="font-size: 16px;" align="center" class="ma-0">
        <span style="color: #47464A; font-weight: 600;" v-if="Feature['nm_field']">{{ Feature["nm_field"] || ""
        }}</span>
        <span style="color: #47464A; font-weight: 600;" v-else>Area</span>
        <v-spacer />
        <v-btn icon depressed @click="onEditClick" :disabled="isDeleting">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.33325 16.6666H6.66658L15.4166 7.91663C15.8586 7.47461 16.1069 6.87509 16.1069 6.24997C16.1069 5.62485 15.8586 5.02533 15.4166 4.5833C14.9746 4.14127 14.375 3.89294 13.7499 3.89294C13.1248 3.89294 12.5253 4.14127 12.0833 4.5833L3.33325 13.3333V16.6666Z"
              stroke="#47464A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.25 5.41669L14.5833 8.75002" stroke="#47464A" stroke-width="1.66667" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </v-btn>
        <field-download-dialog :field="Feature">
          <template v-slot:activator="on">
            <v-btn v-on="on" icon depressed :disabled="isDeleting">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.33325 14.1667V15.8334C3.33325 16.2754 3.50885 16.6993 3.82141 17.0119C4.13397 17.3244 4.55789 17.5 4.99992 17.5H14.9999C15.4419 17.5 15.8659 17.3244 16.1784 17.0119C16.491 16.6993 16.6666 16.2754 16.6666 15.8334V14.1667"
                  stroke="#47464A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.83325 9.16669L9.99992 13.3334L14.1666 9.16669" stroke="#47464A" stroke-width="1.66667"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10 3.33331V13.3333" stroke="#47464A" stroke-width="1.66667" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </v-btn>
          </template>
        </field-download-dialog>
        <v-btn icon depressed @click="onDeleteClick" :loading="isDeleting">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.33325 5.83331H16.6666" stroke="#F75151" stroke-width="1.66667" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M8.33325 9.16669V14.1667" stroke="#F75151" stroke-width="1.66667" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M11.6667 9.16669V14.1667" stroke="#F75151" stroke-width="1.66667" stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M4.16675 5.83331L5.00008 15.8333C5.00008 16.2753 5.17568 16.6993 5.48824 17.0118C5.8008 17.3244 6.22472 17.5 6.66675 17.5H13.3334C13.7754 17.5 14.1994 17.3244 14.5119 17.0118C14.8245 16.6993 15.0001 16.2753 15.0001 15.8333L15.8334 5.83331"
              stroke="#F75151" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333"
              stroke="#F75151" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </v-btn>
        <v-btn icon depressed color="#47464A" @click="onCloseClick" :disabled="isDeleting">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
    </v-card-title>
    <v-card-text>
      <div style="margin-top: 15px;">
        <div style="font-size: 18px; margin-bottom: 20px;">
          <div>Area:</div>
          <div style="margin-top: 10px; color: #47464A;">{{ Feature["fl_area"] | toAreaUnit(Feature["ab_area_unit"]) |
            floatToFixedWithComma }} {{ Feature["ab_area_unit"] }}</div>
        </div>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <span style="margin: auto;" class="caption">{{ Feature["dh_created"] | humanizeDate }}</span>

    </v-card-actions>
  </v-card>
</template>

<script>
import moment from "moment"
import { FEATURE_CARD_STATE } from "../../../../helpers/geometries/constants"
import { FloatingCardsEventBus } from "../../../../helpers/mapview/events"
import { DIALOG_TYPES, DialogOptions } from "../../../../helpers/dialogs"
import FieldDownloadDialog from "./FieldDownloadDialog"
import { getFloatAreaInUnit } from "../../../../helpers/spatial"
import { FEATURE_GROUPS } from "../../../../helpers/leaflet/constants"
import { toFixed } from "../../../../helpers/utils"

const _FieldMap = Symbol.for("_FieldMap")
const _FieldLayer = Symbol.for("_FieldLayer")
const _FieldFeature = Symbol.for("_FieldFeature")

export default {
  name: "FieldViewCard",
  components: { FieldDownloadDialog },
  inject: { _FieldFeature, _FieldLayer, _FieldMap },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isDeleting: false,
  }),
  methods: {
    onCloseClick() {
      FloatingCardsEventBus.$emit("close")
    },
    onDeleteClick() {
      this.$dialog(new DialogOptions({
        title: "Delete Area",
        content: "Are you sure you want to delete this area?",
        type: DIALOG_TYPES.CONFIRM,
        onConfirm: this.deleteHandler
      }))
    },
    deleteHandler() {
      const f = () => {
        this.Map.featureGroups[FEATURE_GROUPS.FEATURES].removeLayer(this.Layer)
        FloatingCardsEventBus.$emit("close")
      }

      this.isDeleting = true
      this.Feature.delete(this.Feature["id_field"], f)
        .catch(() => {
          this.isDeleting = false
        })
    },
    onEditClick() {
      this.$emit("update:mode", FEATURE_CARD_STATE.EDIT)
    },
  },
  filters: {
    humanizeDate(date) {
      return moment(date).format("DD/MM/YYYY")
    },
    toAreaUnit(value, unit) {
      return getFloatAreaInUnit(value, unit)
    },
    floatToFixedWithComma(value) {
      return toFixed(value, 2).replace(".", ",")
    },
  },
  computed: {
    Map() {
      return this._FieldMap()
    },
    Feature() {
      return this._FieldFeature()
    },
    Layer() {
      return this._FieldLayer()
    },
  },
}
</script>

<style scoped></style>
